import * as React from 'react';
import { format } from 'date-fns';
import { reduxForm } from 'redux-form';
import { get, find, filter } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, lifecycle, withState, withHandlers, withPropsOnChange } from 'recompose';

import { withNotifications } from '@components/hoc/withNotifications';
import { getDayPlan, editDayPlan } from '@modules/hr-dayplans/_dayplansActions';
import { PeriodTypesEnum } from '@modules/hr-templates/periods/_periodsEnums';
import { DateField, Date, AutoCompleteField, AutoComplete, ToggleField, Toggle } from '@components/form';
import { required } from '@utils/validators';

const enhance = compose<any, any>(
  withNotifications({ editDayPlan, getDayPlan }),
  withState('dayPlan', 'fetchDayPlan', null),
  withPropsOnChange(['period'], ({ period }) => ({
    isEditing: get(period, 'edit', false)
  })),
  withHandlers({
    onSubmit: ({ isEditing, dayPlan, fetchAllDayPlans, toggleDialog, editDayPlanNotify }) => async editedPeriod => {
      const editedDayplan = isEditing
        ? {
            ...dayPlan,
            periods: dayPlan.periods.map(period => (period.id === editedPeriod.id ? editedPeriod : period))
          }
        : {
            ...dayPlan,
            periods: [...dayPlan.periods, editedPeriod]
          };
      await editDayPlanNotify(editedDayplan).then(
        () => {
          fetchAllDayPlans();
          toggleDialog(false);
        },
        error => console.debug(error)
      );
    },
    deletePeriod: ({
      fetchAllDayPlans,
      toggleDialog,
      dayPlan,
      editDayPlanNotify,
      period: {
        event: { periodId }
      }
    }) => async () => {
      const filteredPeriods = filter(dayPlan.periods, p => p.id !== periodId);
      await editDayPlanNotify({ ...dayPlan, periods: filteredPeriods }).then(
        () => {
          fetchAllDayPlans();
          toggleDialog(false);
        },
        error => console.debug(error)
      );
    }
  }),
  reduxForm({ form: 'periodForm' }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { isEditing, period, fetchDayPlan, initialize, dayPlans, getDayPlanNotify } = this.props;
      const start = get(period, 'slot.start');
      const end = get(period, 'slot.end');
      const dayPlanId = isEditing
        ? period.event.dayPlanId
        : get(find(dayPlans, { date: format(start, 'YYYY-MM-DD') }), 'id');

      await getDayPlanNotify(dayPlanId).then(
        dayPlan => {
          fetchDayPlan(dayPlan);
          if (isEditing) {
            const editedPeriod = find(dayPlan.periods, { id: get(period, 'event.periodId') });
            initialize(editedPeriod);
          } else {
            initialize({
              from: format(start, 'YYYY-MM-DD[T]HH:mm:ss'),
              to: format(end, 'YYYY-MM-DD[T]HH:mm:ss')
            });
          }
        },
        error => console.debug(error)
      );
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, isEditing, toggleDialog, deletePeriod, change }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col xs={12} md={5}>
            <DateField component={Date} name="from" label="Od" dateOnly={false} disabled={false} />
          </Col>
          <Col md={2} />
          <Col xs={12} md={5}>
            <DateField component={Date} name="to" label="Do" dateOnly={false} disabled={false} allowFuture={true} />
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <AutoCompleteField
              component={AutoComplete}
              id="type"
              name="type"
              label="Typ intervalu *"
              items={PeriodTypesEnum}
              fullWidth={true}
              labelFunction={o => get(o, 'label')}
              valueFunction={o => get(o, 'id')}
              validate={[required]}
            />
          </Col>
          <Col md={5}>
            <div style={{ marginTop: 5, marginBottom: 10, fontSize: 12 }}>Odpracováno</div>
            <ToggleField
              component={Toggle}
              name="isWorked"
              label="Odpracováno"
              labelPosition="right"
              onToggle={(_, value) => change('isWorked', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button label="Uložit" type="submit" primary={true} style={{ margin: '15px 15px 0 0' }} />
            {isEditing && <Button label="Smazat" onClick={() => deletePeriod()} style={{ margin: '15px 15px 0 0' }} />}
            {!isEditing && (
              <Button label="Zrušit" onClick={() => toggleDialog(false)} style={{ margin: '15px 15px 0 0' }} />
            )}
          </Col>
        </Row>
      </Grid>
    </form>
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-employee-detail/PeriodForm.tsx